import React, { Component } from 'react';
import Page from '../../containers/page';

import {
    Container,
    Row,
    Col

} from 'reactstrap';

import Isvg from "react-inlinesvg";

import { formValueSelector } from 'redux-form';  // ES6
import { connect } from 'react-redux';
import addIcon from '../../assets/svg/add-icon.svg';
import edit from '../../assets/svg/edit.svg'
import garabage from '../../assets/svg/garbage.svg'

import FormBuilder from '../../components/forms/modalFormBuilder';
import { required, requiredAlphaNumUnderscore } from '../../components/forms/validation';

import ListBuilder from '../../components/listBuilder';
import DeleteModal from '../../components/deleteModal';
import ErrorModal from '../../components/errorModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../helpers/linkHelper';
import { API_ENDPOINT } from '../../constants';

import Toggle from '../../components/forms/fields/toggle';

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

class AnalyticsPixels extends Component {
    constructor(props) {
        super(props);
        this.player = React.createRef();
        this.player2 = React.createRef();
        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0
            },
            items: [],
            total: 0,
            defaultColor: '#E0BEEC',
            forms: []
        };
    }

    get = () => {
        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, group: this.props.selectedGroup, clinic: this.props.selectedClinic })).then((data) => {
                this.setState({
                    ...data,
                    loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, group: this.props.selectedGroup, clinic: this.props.selectedClinic })).then((data) => {
                let dataToSet = { ...data }
                if (dataToSet.page || dataToSet.items || dataToSet.total) {
                    dataToSet.loading = null;
                    // console.log(dataToSet.page || dataToSet.items || dataToSet.total)
                    let checkFilter = '';
                    if (dataToSet.resultFilter) {
                        checkFilter = String(dataToSet.resultFilter)
                        delete dataToSet.resultFilter;
                    }
                    let search = this.props[0].location.search;
                    let serachParams = getSearchParams(search);
                    let searchParamsFilter = '';
                    if (serachParams.filter) {
                        searchParamsFilter = serachParams.filter;
                    }
                    if (searchParamsFilter != checkFilter) {
                        delete dataToSet.page;
                        delete dataToSet.items;
                        delete dataToSet.total;
                        delete dataToSet.loading;
                    }
                }
                this.setState({
                    ...dataToSet,
                    // loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }



    }

    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        this.get();
    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }

        if (prevProps.selectedGroup != this.props.selectedGroup || prevProps.selectedClinic != this.props.selectedClinic) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })

        }
    }

    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field;
            state.sortType = type;
            this.setState({
                params: state
            })
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, [{ name: 'sortField', value: field }, { name: 'sortType', value: type }], false));

        }
    }

    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                obj[name] = value;
                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                obj[name] = value;
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLink(this.props[0].location.search, { entries: 10, page: 0 }, name, value, restart));
        }
    }
    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });

            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, fields, restart));
        }
    }


    insertOrUpdate = (data) => {
        const id = data._id ?? 'new';
        let obj = {
            name: data.name,
            type: data.type,
            apiSecret: data.apiSecret,
            measurementId: data.measurementId,
            accessToken: data.accessToken,
            pixelId: data.pixelId,
            eventName: data.eventName,
            isActive: data.isActive ? true : false,
            groupId: this.props.selectedGroup,
            clinicId: this.props.selectedClinic,
            forms: data.forms,
            map: data.map,
        }
        fetch(API_ENDPOINT + '/data/analytics-pixels/' + id, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(parseJSON).then(({ result, status }) => {
            if (result.error) {
                this.setState({ error: result.error })
            } else {
                this.get();
                this.props.verifyUser();
                this.setState({
                    form: null,
                })
            }

        })
    }

    delete = (data) => {
        this.setState({
            loading: true
        }, () => {

            fetch(API_ENDPOINT + '/data/analytics-pixels/' + data._id, {
                method: 'DELETE',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }

            }).then(parseJSON).then(({ result, status }) => {
                if (result.error) {
                    this.setState({ error: result.error })
                }
                this.get();
            })
        })

    }

    render() {
        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })
        }


        let fields = [
            { type: 'text', name: 'name', label: 'Name'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'type', label: 'Type'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'switch', label: 'Inactive/Active'.translate(this.props.lang), allowSort: true, defaultSort: -1 },

        ];

        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>

                <Container fluid>
                    <Row>
                        <Col lg="12">
                            <div className="panel">

                                <div className="panel-header">
                                    <h5 className="component-header">{this.props.linksMeta && this.props.linksMeta[this.props[0].location.pathname] ? this.props.linksMeta[this.props[0].location.pathname][this.props.lang] : ''}
                                    </h5>
                                    <button
                                        className="btn add-button"
                                        onClick={() => {
                                            this.setState({
                                                form: {
                                                    calendarColor: this.state.defaultColor,
                                                }
                                            })
                                        }}
                                    >
                                        <Isvg src={addIcon} /> {'Add'.translate(this.props.lang)}
                                    </button>
                                </div>
                                <ListBuilder
                                    lang={this.props.lang}
                                    loading={this.state.loading}
                                    total={this.state.total}
                                    showNumeration={false}

                                    fields={fields}
                                    items={this.state.items.map(item => {
                                        return {
                                            ...item,
                                            type: item.type === 'google' ? 'Google'.translate(this.props.lang) : item.type === 'meta' ? 'Meta'.translate(this.props.lang) : 'N/A',
                                            switch: <div style={{ height: 33, width: 100, marginTop: -18 }}>
                                                <Toggle value={item.isActive ? item.isActive : false} onChange={(e) => { this.insertOrUpdate({ ...item, isActive: e.target.checked }) }} ></Toggle> </div>

                                        }
                                    })}
                                    actions={
                                        [

                                            {
                                                component: <div className="tabel-action-tooltip"> <Isvg src={edit} /> <div className="chat-icons-tooltip">{'Edit'.translate(this.props.lang)}</div> </div>,
                                                onClick: (item) => {
                                                    let obj = { ...item };
                                                    if (!obj.map) {
                                                        obj.map = [
                                                            {
                                                                query: 'session_id', location: 'params', name: 'session_id',
                                                            },
                                                            {
                                                                query: 'campaign_id', location: 'params', name: 'campaign_id',
                                                            },
                                                            {
                                                                query: 'utm_source', location: 'params', name: 'source',
                                                            },
                                                            {
                                                                query: 'gclid', location: 'user_properties', name: 'gclid',
                                                            },
                                                            {
                                                                query: 'gclid', location: 'params', name: 'gclid_value',
                                                            },
                                                        ]
                                                    }
                                                    this.setState({ form: obj })
                                                }

                                            },
                                            {
                                                component: <div className="tabel-action-tooltip"> <Isvg src={garabage} /> <div className="chat-icons-tooltip">{'Delete'.translate(this.props.lang)}</div> </div>,
                                                onClick: (item) => this.setState({ deleteModal: item })
                                            },
                                        ]
                                    }
                                    rawItems={this.state.items}
                                    params={params}
                                    sortField={params.sortField}
                                    sortType={params.sortType}
                                    updateSort={this.updateSort}
                                    updateParams={this.updateParams}
                                    updateMultipleParams={this.updateMultipleParams}
                                ></ListBuilder>
                                <DeleteModal
                                    lang={this.props.lang}
                                    isOpen={this.state.deleteModal}
                                    toggle={() => this.setState({ deleteModal: null })}
                                    handler={() => { this.delete(this.state.deleteModal); this.setState({ deleteModal: null }) }}
                                >
                                    {'Delete template'.translate(this.props.lang)} <strong>{this.state.deleteModal && this.state.deleteModal.name}</strong>?
                                </DeleteModal>
                                {this.state.error ?

                                    <ErrorModal lang={this.props.lang}
                                        isOpen={this.state.error}
                                        toggle={() => this.setState({ error: null })}

                                    >
                                        {this.state.error.translate(this.props.lang)}
                                    </ErrorModal>

                                    :
                                    null
                                }




                            </div>
                        </Col>
                    </Row>

                </Container>
                {this.state.form ?
                    <FormBuilder
                        selectedGroup={this.props.selectedGroup}
                        selectedClinic={this.props.selectedClinic}
                        countryTwoLetter={this.props.countryTwoLetter}
                        country={this.props.country}
                        dateFormat={this.props.dateFormat}
                        getStringDateTs={this.props.getStringDateTs}
                        lang={this.props.lang}
                        onSubmit={(data) => {
                            this.insertOrUpdate(data)
                        }
                        }
                        initialValues={this.state.form}
                        size="lg"
                        isOpen={this.state.form}
                        toggle={() => this.setState({ form: null, doctorPermissions: false })}
                        title={this.state.form._id ? 'Edit Pixel'.translate(this.props.lang) : 'Add new Pixel'.translate(this.props.lang)}
                        buttonText={'Save'.translate(this.props.lang).translate(this.props.lang)}
                        disabledCreatedInfo={true}
                        fields={[
                            {
                                type: 'row',
                                children: [
                                    {
                                        type: 'col',
                                        width: {
                                            lg: 6,
                                            sm: 12,
                                            xs: 12
                                        },
                                        children: [
                                            {
                                                type: 'text',
                                                name: 'name',
                                                label: 'Name'.translate(this.props.lang),
                                                validate: [required('Name is required!'.translate(this.props.lang))]

                                            },
                                        ]
                                    },
                                    {
                                        type: 'col',
                                        width: {
                                            lg: 6,
                                            sm: 12,
                                            xs: 12
                                        },
                                        children: [
                                            {
                                                type: 'select',
                                                name: 'type',
                                                label: 'Type'.translate(this.props.lang),
                                                values: [
                                                    { value: -1, name: 'Select'.translate(this.props.lang) },
                                                    { name: 'Google'.translate(this.props.lang), value: 'google' },
                                                    { name: 'Meta'.translate(this.props.lang), value: 'meta' },
                                                ],
                                                validate: [required('Type is required!'.translate(this.props.lang))]
                                            }
                                        ]
                                    },
                                    this.props.pixelType === 'google' ?
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 12,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'text',
                                                    name: 'apiSecret',
                                                    label: 'API Secret'.translate(this.props.lang),
                                                    validate: [required('API Secret is required!'.translate(this.props.lang))]
                                                }
                                            ]
                                        } :
                                        this.props.pixelType === 'meta' ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'text',
                                                        name: 'accessToken',
                                                        label: 'Access Token'.translate(this.props.lang),
                                                        validate: [required('Access Token is required!'.translate(this.props.lang))]
                                                    }
                                                ]
                                            } : null
                                    ,
                                    this.props.pixelType === 'google' ?

                                        {
                                            type: 'col',
                                            width: {
                                                lg: 12,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'text',
                                                    name: 'measurementId',
                                                    label: 'Measurement ID'.translate(this.props.lang),
                                                    validate: [required('Measurement ID is required!'.translate(this.props.lang))]
                                                }
                                            ]
                                        } :
                                        this.props.pixelType === 'meta' ?
                                            {
                                                type: 'col',
                                                width: {
                                                    lg: 12,
                                                    sm: 12,
                                                    xs: 12
                                                },
                                                children: [
                                                    {
                                                        type: 'text',
                                                        name: 'pixelId',
                                                        label: 'Pixel ID'.translate(this.props.lang),
                                                        validate: [required('Pixel ID is required!'.translate(this.props.lang))]
                                                    }
                                                ]
                                            } : null,
                                    this.props.pixelType ?
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 12,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'text',
                                                    name: 'eventName',
                                                    label: 'Event Name'.translate(this.props.lang),
                                                    validate: [requiredAlphaNumUnderscore('Event Name is required!'.translate(this.props.lang), 'Only lowercase letters, digits and _ allowed'.translate(this.props.lang))]
                                                }
                                            ]
                                        } : null,
                                    this.props.pixelType ?
                                        {
                                            type: 'col',
                                            width: {
                                                lg: 12,
                                                sm: 12,
                                                xs: 12
                                            },
                                            children: [
                                                {
                                                    type: 'analytics-parameter-map',
                                                    name: 'map',
                                                    pixelType: this.props.pixelType,
                                                    label: 'Event Name'.translate(this.props.lang),
                                                }
                                            ]
                                        } : null,

                                    this.props.pixelType ? {
                                        type: 'col',
                                        width: {
                                            lg: 12,
                                            sm: 12,
                                            xs: 12
                                        },

                                        children: [
                                            {
                                                type: 'multi-select-modal',
                                                name: 'forms',
                                                // disableFilter: true,
                                                // selectAllAndDisableValues: this.props.selectAllAndDisableValues ? true : false,
                                                label: 'Select from(s)'.translate(this.props.lang),
                                                values: this.state.forms?.map((item, idx) => { return { name: item.name, value: item._id } }),
                                                lang: this.props.lang,

                                            }
                                        ]
                                    } : null
                                ]
                            }
                        ]}

                    ></FormBuilder>
                    :
                    null
                }
            </div>
        );
    }
}


const selector = formValueSelector('modalForm');

export default connect(state => {
    return {
        pixelType: selector(state, 'type'),
    }
}, {

})(Page(AnalyticsPixels));
